export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    year = "",
    assetType = "",
    details = [],
    totalHistoricalCost = 0,
    totalDepreciationAmount = 0,
    totalAccumulatedDepreciation = 0,
    totalPages = "",
    openingDate = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let tableRows = details.map((item) => `
    <tr>
      <td class="border text-center">${item.ordinalNumber || ""}</td>
      <td class="border text-center">${item.increaseDocNumber || ""}</td>
      <td class="border text-center">${item.increaseDocDate || ""}</td>
      <td class="border px-1">${item.assetName || ""}</td>
      <td class="border text-center">${item.manufacturingCountry || ""}</td>
      <td class="border text-center">${item.useMonthYear || ""}</td>
      <td class="border text-center">${item.assetId || ""}</td>
      <td class="border text-right px-1">${fmt(item.historicalCost)}</td>
      <td class="border text-center">${fmt(item.depreciationRate)}</td>
      <td class="border text-right px-1">${fmt(item.depreciationAmount)}</td>
      <td class="border text-right px-1">${fmt(item.accumulatedDepreciationUntilReduction)}</td>
      <td class="border text-center">${item.decreaseDocNumber || ""}</td>
      <td class="border text-center">${item.decreaseDocDate || ""}</td>
      <td class="border px-1">${item.decreaseReason || ""}</td>
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 10px; color: black; line-height: 1.3;">
      <table width="100%">
        <tr>
          <td width="40%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="60%" align="center">
            <div class="font-bold">Mẫu số S21-DN</div>
            <div style="font-style: italic; font-size: 9px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 15px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 14px;">SỔ TÀI SẢN CỐ ĐỊNH</h2>
        <div style="margin-top: 5px; font-weight: bold;">Năm: ${year}</div>
        <div style="margin-top: 5px;">Loại tài sản: <span class="dotted-line" style="width: 250px; display: inline-block;">${assetType}</span></div>
      </div>

      <table class="table-full" width="100%" style="border-collapse: collapse; margin-top: 10px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="30">Số TT</th>
            <th class="border" colspan="7">Ghi tăng tài sản cố định</th>
            <th class="border" colspan="3">Khấu hao tài sản cố định</th>
            <th class="border" colspan="3">Ghi giảm tài sản cố định</th>
          </tr>
          <tr>
            <th class="border" colspan="2">Chứng từ</th>
            <th class="border" rowspan="2">Tên, đặc điểm, ký hiệu TSCĐ</th>
            <th class="border" width="50" rowspan="2">Nước sản xuất</th>
            <th class="border" width="55" rowspan="2">Tháng năm sử dụng</th>
            <th class="border" width="50" rowspan="2">Số hiệu TSCĐ</th>
            <th class="border" width="80" rowspan="2">Nguyên giá</th>
            <th class="border" width="40" rowspan="2">Tỷ lệ (%)</th>
            <th class="border" width="80" rowspan="2">Mức khấu hao</th>
            <th class="border" width="80" rowspan="2">KH đã tính khi giảm</th>
            <th class="border" colspan="2">Chứng từ</th>
            <th class="border" rowspan="2">Lý do giảm TSCĐ</th>
          </tr>
          <tr>
            <th class="border">A</th>
            <th class="border" width="45">Số hiệu</th>
            <th class="border" width="55">Ngày</th>
            <th class="border" width="45">Số hiệu</th>
            <th class="border" width="55">Ngày</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">E</th>
            <th class="border">G</th>
            <th class="border">H</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">4</th>
            <th class="border">I</th>
            <th class="border">K</th>
            <th class="border">L</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
          <tr style="font-weight: bold; background-color: #fafafa;">
            <td class="border text-center" colspan="7">Cộng</td>
            <td class="border text-right px-1">${fmt(totalHistoricalCost)}</td>
            <td class="border text-center">X</td>
            <td class="border text-right px-1">${fmt(totalDepreciationAmount)}</td>
            <td class="border text-right px-1">${fmt(totalAccumulatedDepreciation)}</td>
            <td class="border text-center">X</td>
            <td class="border text-center">X</td>
            <td class="border text-center">X</td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top: 15px;">
        <div>- Sổ này có <span class="dotted-line">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <span class="dotted-line">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 25px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 9px;">(Ký, họ tên)</div>
            <div style="margin-top: 50px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 9px;">(Ký, họ tên)</div>
            <div style="margin-top: 50px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 9px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 9px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 50px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 3px; }
        .table-full { border: 1px solid black; }
        .dotted-line { border-bottom: 1px dotted black; padding: 0 10px; }
      </style>
    </div>
  `;
};
